export default {
  everyText: 'Оберіть',
  emptyMonths: 'Оберіть місяць',
  emptyMonthDays: 'Оберіть день місяця',
  emptyMonthDaysShort: 'Оберіть день місяця',
  emptyWeekDays: 'Оберіть день тижня',
  emptyWeekDaysShort: 'Оберіть день тижня',
  emptyHours: 'Оберіть годину',
  emptyMinutes: 'Оберіть хвилину',
  emptyMinutesForHourPeriod: 'Оберіть',
  yearOption: 'рік',
  monthOption: 'місяць',
  weekOption: 'тиждень',
  dayOption: 'день',
  hourOption: 'година',
  minuteOption: 'хвилина',
  rebootOption: 'перезагрузити',
  prefixPeriod: 'Кожен',
  prefixMonths: 'в',
  prefixMonthDays: 'в',
  prefixWeekDays: 'в',
  prefixWeekDaysForMonthAndYearPeriod: 'і',
  prefixHours: 'о',
  prefixMinutes: ':',
  prefixMinutesForHourPeriod: 'в',
  suffixMinutesForHourPeriod: 'хвилин',
  errorInvalidCron: 'Невірне значення',
  clearButtonText: 'Очистити',
  weekDays: [
    // Order is important, the index will be used as value
    'Неділя', // Sunday must always be first, it's "0"
    'Понеділок',
    'Вівторок',
    'Середа',
    'Четвер',
    "П'ятниця",
    'Субота',
  ],
  months: [
    // Order is important, the index will be used as value
    'Січень',
    'Лютий',
    'Березень',
    'Квітень',
    'Травень',
    'Червень',
    'Липень',
    'Серпень',
    'Вересень',
    'Жовтень',
    'Листопад',
    'Грудень',
  ],
  // Order is important, the index will be used as value
  altWeekDays: [
    'НЕД', // Sunday must always be first, it's "0"
    'ПОН',
    'ВТР',
    'СРД',
    'ЧТВ',
    'ПТН',
    'СУБ',
  ],
  // Order is important, the index will be used as value
  altMonths: ['СІЧ', 'ЛЮТ', 'БЕР', 'КВІ', 'ТРА', 'ЧЕР', 'ЛИП', 'СЕР', 'ВЕР', 'ЖОВ', 'ЛИС', 'ГРУ'],
};
